import 'Styles/templates/page.store-locator.scss';
import StoreBody from '../vue/store/store-body';

StoreBody();